import dateFormat from 'dateformat';
import { getNumberFormat } from '../../../../../utils/number-utils';
import Form from '../../../../../form_builder_2/form';
import { elementResize, scrollToElement } from '../../../../../utils/dom';
import Tooltip from '../../../../../utils/tooltip';
import { pushEmailAnalytics } from '../../../../../utils/ecomm-email-analytics';

export default class PartExchangeSaved {
    constructor(parent) {
        this.parent = parent;
        this.partEx = parent.partEx;
        this.pricing = parent.pricing;
        this.el = parent.el;
        this.formatPrice = parent.formatPrice;

        this.displayState = {
            visible: [],
            hidden: [],
        };

        this.setSelectors();
        this.getInitialDisplayState();
        this.setTemplates();
        this.initForms();
        this.bind();
    }

    async preselect() {
        this.parent.showLoader();
        await this.showSavedView();
        await this.pricing.waitForMTOCEPricing();
        const savedValuation = this.getSavedOption(this.partEx.id);
        if (savedValuation) {
            this.onValuationSelect(savedValuation);
            this.savedOutstandingFinanceAmount.value = this.partEx.finance;
            this.showSavedOutstandingFinance(null, (!isNaN(this.partEx.finance) && Number(this.partEx.finance) > 0));
            const valid = await this.savedFinanceForm.valid();
            this.savedFinanceForm.submit(valid);
        } else {
            this.partEx.reset();
        }

        this.parent.hideLoader();
    }

    setSelectors() {
        this.noMoreValuationsSaved = this.el.querySelector('#part-ex-saved-no-valuation-warning');
        this.savedVehicleDetails = this.el.querySelector('#part-ex-saved-vehicle-details');

        // saved journey
        this.savedSection = this.el.querySelector('#part-ex-saved');
        this.savedFinanceBlock = this.savedSection.querySelector('#part-ex-saved-finance-form');
        this.savedValuationBlock = this.savedSection.querySelector('#part-ex-saved-valuation');
        this.savedValuationEstimateBlockLeft = this.savedSection.querySelector('#part-ex-saved-estimate-block-left');
        this.savedValuationEstimateBlockRight = this.savedSection.querySelector('#part-ex-saved-estimate-block-right');
        this.savedOptions = this.savedSection.querySelector('#part-ex-saved-options');
        this.savedValuationDisclaimer = this.savedSection.querySelector('.copy--small');

        this.savedOutstandingFinanceYes = this.savedFinanceBlock.querySelector('#part-ex-saved-outstanding-yes');
        this.savedOutstandingFinanceNo = this.savedFinanceBlock.querySelector('#part-ex-saved-outstanding-no');
        this.savedOutstandingFinanceInput = this.savedFinanceBlock.querySelector('#part-ex-saved-os-finance-input');

        this.savedFinanceSubmitButton = this.savedFinanceBlock.querySelector('.form_submit_wrapper');

        this.savedOutstandingFinanceAmount = this.savedFinanceBlock.querySelector('#saved-outstanding-finance-amount');
    }

    getInitialDisplayState() {
        const elements = [
            this.noMoreValuationsSaved,
            this.savedVehicleDetails,
            this.savedSection,
            this.savedFinanceBlock,
            this.savedValuationBlock,
            this.savedValuationEstimateBlockLeft,
            this.savedValuationEstimateBlockRight,
            this.savedValuationDisclaimer,
            this.savedOptions,
            this.savedOutstandingFinanceYes,
            this.savedOutstandingFinanceNo,
            this.savedOutstandingFinanceInput,
            this.savedFinanceSubmitButton,
            this.savedOutstandingFinanceAmount,
        ];

        if (elements && elements.length) {
            elements.forEach((ele, i) => {
                if (getComputedStyle(ele).display === 'none') {
                    this.displayState.hidden.push(ele);
                } else {
                    this.displayState.visible.push(ele);
                }
            });
        }
    }

    setTemplates() {
        // templates
        this.templates = {
            carSpecs: _.template(this.el.querySelector('#part-ex-search-vehicle-details-template').innerHTML.replaceAll('\\', '')),
            savedValuationEstimatesLeft: _.template(this.el.querySelector('#part-ex-saved-estimate-block-left-template').innerHTML.replaceAll('\\', '')),
            savedValuationEstimatesRight: _.template(this.el.querySelector('#part-ex-saved-estimate-block-right-template').innerHTML.replaceAll('\\', '')),
            savedOptions: _.template(this.el.querySelector('#part-ex-saved-options-template').innerHTML.replaceAll('\\', '')),
        };
    }

    initForms() {
        this.savedFinanceForm = new Form(this.el.querySelector('#part-ex-saved-finance-form'), {
            onSubmit: () => this.onSavedFinanceSubmit(),
            onSuccess: (result) => this.onSavedFinanceSuccess(result),
            onError: (result) => this.onSavedFinanceError(result),
            action: () => this.savedFinanceAction(),
        });
    }

    bind() {
        this.savedOptions.addEventListener('click', (e) => this.onValuationSelectClick(e));
        this.savedOutstandingFinanceYes.addEventListener('click', (e) => this.showSavedOutstandingFinance(e, true));
        this.savedOutstandingFinanceNo.addEventListener('click', (e) => this.showSavedOutstandingFinance(e, false));

        this.savedValuationEstimateBlockLeft.addEventListener('click', (e) => this.onEditAmount(e));
        this.savedValuationEstimateBlockRight.addEventListener('click', (e) => this.onEditAmount(e));
    }

    onEditAmount(e) {
        const el = e.target.closest('#part-ex-saved-edit-amount');

        if (el) {
            e.preventDefault();

            this.parent.showElements([this.savedFinanceBlock]);
            this.parent.hideElements([
                this.savedValuationBlock,
                this.savedValuationEstimateBlockLeft,
                this.savedValuationEstimateBlockRight,
                this.savedValuationDisclaimer,
            ]);
        }
    }

    onValuationSelectClick(e) {
        e.preventDefault();
        const el = e.target.closest('.btn--default');
        this.onValuationSelect(el);
    }

    getSavedOptions() {
        return [...this.savedOptions.querySelectorAll('.btn--default')];
    }

    getSavedOption(id) {
        return this.getSavedOptions().find((el) => el.dataset.id === id);
    }

    onValuationSelect(el) {
        const allOptions = this.getSavedOptions();
        if (el && !el.classList.contains('active')) {
            this.partEx.valuationSelectedCar = el.dataset.id;
            this.parent.removeActive(allOptions);
            this.parent.setActive([el]);

            this.parent.showElements([this.savedFinanceBlock]);
            this.parent.hideElements([
                this.savedValuationBlock,
                this.savedValuationEstimateBlockLeft,
                this.savedValuationEstimateBlockRight,
                this.savedValuationDisclaimer,
            ]);

            this.parent.showElements([this.savedVehicleDetails]);
            this.parent.removeActive([this.savedOutstandingFinanceYes, this.savedOutstandingFinanceNo]);

            scrollToElement(this.savedVehicleDetails, -20);

            this.renderSavedVehicleDetails();
        }
    }

    renderSavedVehicleDetails() {
        const { valuationSelectedCar, savedValuations } = this.partEx;

        const savedValuation = savedValuations?.data?.find((car) => car.id === valuationSelectedCar);
        const savedValuationData = savedValuation?.data;
        savedValuationData.id = savedValuation?.id;

        const carSpecs = savedValuationData?.providedData?.vehicleSpecifications;
        const mileage = savedValuationData?.providedData?.odometerReading;

        // Vehicle Details desktop view
        const specsTable = this.savedVehicleDetails.querySelector('.configurator--table');
        specsTable.innerHTML = this.templates.carSpecs({
            carSpecs,
            mileage,
            dateFormat,
            formatPrice: this.formatPrice,
            numberFormat: getNumberFormat,
        });

        this.partEx.currentSavedValuation = savedValuationData;
        this.partEx.savedCarSpecs = carSpecs;

        Tooltip.init();
    }

    showSavedOutstandingFinance(e, flag) {
        e?.preventDefault();
        this.partEx.hasSavedOutstandingFinance = false;

        if (flag) {
            this.parent.showElements([
                this.savedOutstandingFinanceInput,
                this.savedFinanceSubmitButton,
            ]);
            this.parent.setActive([this.savedOutstandingFinanceYes]);
            this.parent.removeActive([this.savedOutstandingFinanceNo]);
            this.partEx.hasSavedOutstandingFinance = true;
        } else {
            this.parent.showElements([this.savedFinanceSubmitButton]);
            this.parent.hideElements([this.savedOutstandingFinanceInput]);
            this.parent.removeActive([this.savedOutstandingFinanceYes]);
            this.parent.setActive([this.savedOutstandingFinanceNo]);
            this.partEx.hasSavedOutstandingFinance = false;
        }
    }

    savedFinanceAction() {
        return { success: true, data: this.partEx.currentSavedValuation };
    }

    onSavedFinanceSubmit() {
        this.partEx.savedOutstandingFinanceAmount = this.partEx.hasSavedOutstandingFinance ? Number(this.savedOutstandingFinanceAmount.value) : 0;
    }

    onSavedFinanceSuccess(result) {
        this.parent.hideElements([this.savedFinanceBlock, this.savedVehicleDetails]);
        this.parent.showElements([
            this.savedValuationBlock,
            this.savedValuationEstimateBlockLeft,
            this.savedValuationEstimateBlockRight,
            this.savedValuationDisclaimer,
        ]);

        const savedValuation = result?.data;
        this.partEx.id = savedValuation.id;
        this.partEx.savedValuationAmount = savedValuation.valuation.current.valuation;

        const {
            make, model, colour, registrationNumber,
        } = savedValuation.providedData.vehicleSpecifications;
        this.partEx.savedValuationVehicle = [make, model, colour].join(' ');
        this.partEx.savedCarRegistrationNumber = registrationNumber;
        this.partEx.savedEquity = (Number(this.partEx.savedValuationAmount) - Number(this.partEx.savedOutstandingFinanceAmount)).toFixed(2);

        this.renderSavedValuationEstimate();
        scrollToElement(this.savedValuationBlock, -20);

        this.parent.updateValuationResult({ view: 'saved' });
        pushEmailAnalytics({formName:"exchange_form_submit"});
    }

    onSavedFinanceError(result) {
        this.savedFinanceForm.showError();
    }

    renderSavedValuationEstimate() {
        this.savedValuationEstimateBlockLeft.innerHTML = this.templates.savedValuationEstimatesLeft({
            partEx: this.partEx,
            formatPrice: this.formatPrice,
        });

        this.savedValuationEstimateBlockRight.innerHTML = this.templates.savedValuationEstimatesRight({
            partEx: this.partEx,
            formatPrice: this.formatPrice,
        });

        Tooltip.init();
    }

    renderSavedOptions() {
        this.savedOptions.innerHTML = this.templates.savedOptions({
            partEx: this.partEx,
            dateFormat,
            formatPrice: this.formatPrice,
        });
    }

    async showSavedView() {
        this.parent.showLoader();
        await this.partEx.getCarSavedValuations();
        this.parent.hideLoader();

        this.resetView();

        this.parent.setActive([this.parent.savedButton]);
        this.parent.removeActive([this.parent.searchButton]);

        // Show saved view
        this.parent.showElements([
            this.savedSection,
            this.savedOptions,
        ]);

        if (this.partEx?.savedValuations?.data && this.partEx?.savedValuations?.data.length) {
            this.renderSavedOptions();
            this.parent.showElements(this.savedSection.querySelectorAll('.steps-header'));
            this.parent.hideElements([this.noMoreValuationsSaved]);
            this.savedSection.classList.remove('no-valuations');
        } else {
            this.parent.showElements([this.noMoreValuationsSaved]);
            this.parent.hideElements([...this.savedSection.querySelectorAll('.steps-header'), this.savedOptions]);
            this.savedSection.classList.add('no-valuations');
        }
    }

    hideSavedView() {
        this.parent.hideElements([
            this.savedSection,
            this.savedOptions,
        ]);
    }

    resetView() {
        this.parent.hideElements(this.displayState.hidden);
        this.parent.showElements(this.displayState.visible);
    }
}
